import { createContext, useRef, useState } from "react";
import { useDisclosure } from "@chakra-ui/react";

import type { EsriContextType } from "./esri-context-type";

export const EsriContext = createContext<EsriContextType | null>(null);

const EsriProvider = ({ children }) => {
  const [mapRef, setMapRef] = useState(null);
  const [showInteractions, setInteractionsVisibility] = useState(true);
  const [isActionsVisible, setActionsVisibility] = useState(false);
  const { isOpen: isUnsavedModalOpen, onClose, onOpen } = useDisclosure();
  const [nextModalAction, setNextModalAction] = useState(null);
  const {
    isOpen: isInfoModalOpen,
    onOpen: openInfoModal,
    onClose: closeInfoModal
  } = useDisclosure({ defaultIsOpen: false });

  const openUnsavedModal = () => {
    onOpen();
  };

  const closeUnsavedModal = () => {
    onClose();
    setNextModalAction(null);
    mapRef?.closePopup();
  };

  const handleNextClick = () => {
    onClose();
    nextModalAction();
    setNextModalAction(null);
  };

  const methods = {
    setActionsVisibility,
    setInteractionsVisibility,
    setMapRef,
    openUnsavedModal,
    closeUnsavedModal,
    setNextModalAction,
    handleNextClick,
    openInfoModal,
    closeInfoModal
  };

  const scrollRef = useRef();
  const stateVariables = {
    mapRef,
    showInteractions,
    isActionsVisible,
    isUnsavedModalOpen,
    isInfoModalOpen,
    scrollRef
  };

  return (
    <EsriContext.Provider
      value={{
        ...methods,
        ...stateVariables
      }}
    >
      {children}
    </EsriContext.Provider>
  );
};

export default EsriProvider;
